import { GatherEventEmitter } from "gather-common-including-video/dist/src/public/GatherEventEmitter";
import { Logger } from "../Logger";
import { summarizeMediaStreamTrack } from "../utils";
export var TrackNodeEvent;
(function (TrackNodeEvent) {
    TrackNodeEvent["TrackChanged"] = "TrackChanged";
})(TrackNodeEvent || (TrackNodeEvent = {}));
export class TrackNode extends GatherEventEmitter {
    plugin;
    stream = new MediaStream();
    currentOutputTrack;
    currentInputTrack;
    removeConnection;
    constructor(plugin) {
        super();
        this.plugin = plugin;
        this.plugin.trackChanged = (track) => {
            if (track !== this.currentOutputTrack) {
                if (this.currentOutputTrack) {
                    this.stream.removeTrack(this.currentOutputTrack.get());
                }
                if (track) {
                    this.stream.addTrack(track.get());
                }
                this.currentOutputTrack = track;
                this.publishEvent(TrackNodeEvent.TrackChanged, track);
            }
        };
    }
    connectToInput = (input) => {
        this.removeConnection?.();
        this.removeConnection = input.addEventListener(TrackNodeEvent.TrackChanged, this.processTrack, {
            leading: true,
        });
        return this.stop;
    };
    processTrack = (track) => {
        Logger.debug("[TrackNode] changing input track", track?.get().label, "for plugin", this.plugin.name);
        this.currentInputTrack = track;
        this.plugin.processTrack(track);
    };
    stop = () => {
        this.removeConnection?.();
        this.plugin.stop();
    };
    debugInfo = () => ({
        tracks: this.stream.getTracks().map((t) => summarizeMediaStreamTrack(t)),
        plugin: this.plugin.debugInfo(),
    });
}
//# sourceMappingURL=TrackNode.js.map